/* Copyright 2013 - 2024 Waiterio LLC */
const blogCoverUrl =
  'https://www.imagelato.com/images/blog-cover-successful-restaurant-ffc87d6e.jpg'

export default blogCoverUrl
